const SUPPORT_EMAIL = 'support@airflynow.com';

const SUPPORT_WHATSAPP_NUMBER =
  process.env.REACT_APP_WHATSAPP_PRICE_MATCH_NUMBER || '61481473765';

const SUPPORT_WHATSAPP_DISPLAY = '+61 481 473 765';

const SUPPORT_WHATSAPP_USERNAME = 'airflynow';

function whatsappLink(message = '') {
  const base = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}`;
  return message ? `${base}?text=${encodeURIComponent(message)}` : base;
}

function mailtoLink(subject = '') {
  const base = `mailto:${SUPPORT_EMAIL}`;
  return subject ? `${base}?subject=${encodeURIComponent(subject)}` : base;
}

export {
  SUPPORT_EMAIL,
  SUPPORT_WHATSAPP_NUMBER,
  SUPPORT_WHATSAPP_DISPLAY,
  SUPPORT_WHATSAPP_USERNAME,
  whatsappLink,
  mailtoLink,
};
